var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 16.7168C28 16.982 27.8946 17.2364 27.7071 17.4239C27.5196 17.6114 27.2652 17.7168 27 17.7168H17V27.7168C17 27.982 16.8946 28.2364 16.7071 28.4239C16.5196 28.6114 16.2652 28.7168 16 28.7168C15.7348 28.7168 15.4804 28.6114 15.2929 28.4239C15.1054 28.2364 15 27.982 15 27.7168V17.7168H5C4.73478 17.7168 4.48043 17.6114 4.29289 17.4239C4.10536 17.2364 4 16.982 4 16.7168C4 16.4516 4.10536 16.1972 4.29289 16.0097C4.48043 15.8222 4.73478 15.7168 5 15.7168H15V5.7168C15 5.45158 15.1054 5.19723 15.2929 5.00969C15.4804 4.82215 15.7348 4.7168 16 4.7168C16.2652 4.7168 16.5196 4.82215 16.7071 5.00969C16.8946 5.19723 17 5.45158 17 5.7168V15.7168H27C27.2652 15.7168 27.5196 15.8222 27.7071 16.0097C27.8946 16.1972 28 16.4516 28 16.7168Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon_plus.40cf1683f8d8e8649d53df74e4907384.svg";
export { ForwardRef as ReactComponent };